/* STG quick shop — pairs with snippets/stg-quick-shop.liquid. Loaded once per page. */
(function(){
  if (window.__stgQuickShop) return;
  window.__stgQuickShop = true;

  function money(cents, fmt){
    var val = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, val)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, val.replace('.', ','))
      .replace(/<[^>]*>/g, '');
  }
  function data(qs){
    if (!qs.__d){ try { qs.__d = JSON.parse(qs.querySelector('[data-qs-json]').textContent); } catch(e){ qs.__d = null; } }
    return qs.__d;
  }
  function state(qs){
    var D = data(qs);
    var vSel = qs.querySelector('[data-qs-variant]');
    var vid = vSel ? vSel.value : String(D.variant);
    var v = D.variants[vid];
    var mode = qs.querySelector('[data-qs-mode]:checked');
    var sub = mode ? mode.value === 'sub' : (D.plans.length > 0 && !qs.querySelector('[data-qs-mode]'));
    if (!D.plans.length) sub = false;
    var pSel = qs.querySelector('[data-qs-plan]');
    var plan = sub ? (pSel ? pSel.value : String(D.plans[0])) : null;
    var unit = (plan && v.alloc[plan] != null) ? v.alloc[plan] : v.price;
    return { D: D, vid: vid, v: v, plan: plan, unit: unit };
  }
  function render(qs){
    var st = state(qs); if (!st.v) return;
    var once = qs.querySelector('[data-qs-once-price]'); if (once) once.textContent = money(st.v.price, st.D.moneyFormat);
    var subP = qs.querySelector('[data-qs-sub-price]');
    if (subP){
      var pSel = qs.querySelector('[data-qs-plan]');
      var pid = pSel ? pSel.value : String(st.D.plans[0]);
      subP.textContent = money(st.v.alloc[pid] != null ? st.v.alloc[pid] : st.v.price, st.D.moneyFormat);
    }
    var planWrap = qs.querySelector('[data-qs-plan]');
    if (planWrap){ planWrap.disabled = !st.plan; }
    var c = qs.querySelector('[data-qs-confirm]');
    if (c){
      c.disabled = !st.v.available;
      c.textContent = st.v.available ? st.D.confirmTpl.split('{total}').join(money(st.unit, st.D.moneyFormat)) : 'Sold out';
    }
  }
  function add(qs, btn){
    var st = state(qs); if (!st.v || !st.v.available) return;
    var item = { id: parseInt(st.vid, 10), quantity: 1 };
    if (st.plan) item.selling_plan = parseInt(st.plan, 10);
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { items: [item] };
    if (cart && cart.getSectionsToRender){
      body.sections = cart.getSectionsToRender().map(function(x){ return x.id; });
      body.sections_url = window.location.pathname;
    }
    var err = qs.querySelector('[data-qs-err]'); if (err){ err.hidden = true; err.textContent = ''; }
    btn.classList.add('is-loading');
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if (res.status){
          var msg = res.description || res.message || 'Could not add to cart.';
          if (err){ err.textContent = msg; err.hidden = false; } else { window.alert(msg); }
          return;
        }
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'stg-quick-shop', cartData: res });
        close(qs);
        if (cart && cart.renderContents && res.sections){ cart.renderContents(res); if (cart.classList) cart.classList.remove('is-empty'); }
        else { window.location = (window.routes && window.routes.cart_url) || '/cart'; }
      })
      .catch(function(){ if (err){ err.textContent = 'Could not add to cart. Please try again.'; err.hidden = false; } })
      .finally(function(){ btn.classList.remove('is-loading'); });
  }
  function close(qs){
    var p = qs.querySelector('[data-qs-panel]'); if (p) p.hidden = true;
    var a = qs.querySelector('[data-qs-add]'); if (a && a.hasAttribute('aria-expanded')) a.setAttribute('aria-expanded', 'false');
    qs.classList.remove('is-open');
  }

  document.addEventListener('click', function(e){
    var addBtn = e.target.closest('[data-qs-add]');
    if (addBtn){
      var qs = addBtn.closest('[data-stg-qs]'); var D = qs && data(qs); if (!D) return;
      if (D.direct){ add(qs, addBtn); return; }
      var panel = qs.querySelector('[data-qs-panel]');
      var open = panel.hidden;
      panel.hidden = !open;
      addBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      qs.classList.toggle('is-open', open);
      if (open){ render(qs); var first = panel.querySelector('input:checked, select, button'); if (first) first.focus(); }
      return;
    }
    var conf = e.target.closest('[data-qs-confirm]');
    if (conf){ add(conf.closest('[data-stg-qs]'), conf); }
  });
  document.addEventListener('click', function(e){
    document.querySelectorAll('[data-stg-qs].is-open').forEach(function(qs){ if (!qs.contains(e.target)) close(qs); });
  }, true);
  document.addEventListener('change', function(e){
    if (e.target.matches('[data-qs-mode], [data-qs-variant], [data-qs-plan]')){
      var qs = e.target.closest('[data-stg-qs]'); if (qs) render(qs);
    }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var qs = e.target.closest && e.target.closest('[data-stg-qs].is-open');
    if (qs){ close(qs); var a = qs.querySelector('[data-qs-add]'); if (a) a.focus(); }
  });
})();
